export const contact = {
  msgEmail: {
    label: 'Email',
    placeholder: 'Adresse mail...',
  },
  msgSubject: {
    label: 'Objet de votre message',
    placeholder: 'Objet...',
    error: 'Merci de saisir au moins 3 caractères.',
  },
  msgContent: {
    label: "Message à adresser à l'administrateur (au moins 6 caractères)",
    placeholder: 'Message...',
    error: 'Merci de saisir au moins 6 caractères.',
  },
  btn: {
    cancel: 'Effacer',
    ok: 'Envoyer',
  },
  msg: {
    CONTACT_ERR_01: "L'email est obligatoire et doit être valide.",
    CONTACT_ERR_02: "L'objet est obligatoire.",
    CONTACT_ERR_03: 'Le message est obligatoire.',
    CONTACT_ERR_04:
      "Impossible d'envoyer le mail car il n'y a pas d'administrateur actif. Veuillez nous excuser pour ce désagrément.",
    CONTACT_ERR_05:
      "Erreur technique lors de l'envoi du mail. Veuillez nous excuser pour ce désagrément.",
    warning01: 'Message "{subject}" non envoyé à cause d\'une erreur SMTP.',
    success01: 'Message envoyé avec succès !',
    success02:
      'Message synchronisé. Il sera envoyé quand la connexion sera revenue.',
    success03: 'Message "{subject}" envoyé avec succès.',
  },
};
